import * as moment from "moment";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { workflowRepository } from "motw_core/Repositories/WorkflowRepository";
import { GetAllVisibleNodesAsync } from "motw_core/Workflows/GetVisibleNodes";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { RefreshVisibleWorkflowNodesAsync } from "source/app/presentation/MainPanel/Workflows/Helpers/RefreshVisibleWorkflowNodes";
import { IRootNodeFormState } from "source/app/presentation/MainPanel/Workflows/RootNodeName/Helpers/IRootNodeFormState";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import { AddNodeAsync } from "source/app/services/Workflows/ChangeData/AddNodeAsync";
import { GotoNodeAsync } from "source/app/services/Workflows/GotoNode";
import { diaryEntriesNodeName } from "source/app/services/Workflows/NodeNameConstants";
import { SetRootNodeAsync } from "source/app/services/Workflows/SetRootNode";
import * as toastr from "toastr";
import { SetState } from "../../State/SetState";

export async function GoToLatestDiaryEntryAsync() {
    const parentNode = await workflowRepository.GetNodeByNameAsync(
        ClientDataProvider,
        diaryEntriesNodeName
    );

    if (!parentNode) {
        toastr.info(`Diary entries node was not found`);
        return;
    }

    const childNodes = await WithAnimatedProgressBarAsync(() =>
        GetAllVisibleNodesAsync(parentNode)
    );

    if (!childNodes) {
        return;
    }

    const todaysDate = moment().format(`YYYYMMDD`);

    const todaysDiaryEntries = childNodes
        .filter((node) => node.name !== diaryEntriesNodeName)
        .filter((node) => node.name.split(`\n`)[0] === todaysDate);

    if (todaysDiaryEntries.length === 1) {
        await SetRootNodeAsync(todaysDiaryEntries[0].id);

        setTimeout(
            () =>
                SetState<IRootNodeFormState>(
                    ESharedFunction.RootNodeName_state,
                    {
                        showEditControls: true,
                    }
                ),
            500 // Expecting diary entry to have been ready within this time
        );

        return;
    }

    if (todaysDiaryEntries.length === 0) {
        await GotoNodeAsync(diaryEntriesNodeName);
        toastr.info(`No diary entries exist for the date "${todaysDate}"`);

        WithAnimatedProgressBarAsync(async () => {
            await AddNodeAsync({
                name: todaysDate,
                parentid: parentNode.id,
            });

            toastr.info(`Created diary entry for the date "${todaysDate}"`);
            await RefreshVisibleWorkflowNodesAsync();
            return;
        });
    }

    if (todaysDiaryEntries.length > 1) {
        toastr.warn(
            `Multiple diary entries exist for the date "${todaysDate}"`
        );

        return;
    }
}
